<template></template>

<script>
export default {
  name: "BlankVue",
  data() {
    return {
      bookId: "",
      currentChapterId: "",
    };
  },
  methods: {
    jumpToChapterVue() {
      this.$router.push({
        path: "ChapterDetailVue",
        query: {
          bookId: this.bookId,
          chapterId: this.currentChapterId,
        },
      });
    },
  },
  created() {
    this.bookId = this.$route.query.bookId;
    this.currentChapterId = this.$route.query.chapterId;
    this.jumpToChapterVue();
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("js", new Date());
    gtag("config", "AW-863726682");

    //Event snippet for 開始進入專題跳轉中間頁
    gtag("event", "conversion", {
      send_to: "AW-863726682/IpKYCOaPh-wBENrY7ZsD",
    });
    console.log(
      "google 像素 進入 專題跳轉中間頁: 'AW-863726682/IpKYCOaPh-wBENrY7ZsD"
    );
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BlankVue.vue